/* eslint-disable */
import Vue from 'vue'
import Utils from '../../utils/utils'
/* eslint-enable */
export function queryTips (condition) {
  return Vue.http.post(Utils.paths.Tips.queryTips, condition, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}
export function queryKeywords () {
  return Vue.http.get(Utils.paths.Tips.queryKeywords, {emulateJSON: false}, {headers: {'ContentType': 'application/json'}})
}



// WEBPACK FOOTER //
// ./src/api/modules/RequestTips.js